import React from "react";

function StatCard({ title, value, change }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-5">
      <p className="text-sm text-slate-500">{title}</p>
      <h3 className="text-3xl font-bold text-slate-900 mt-2">{value}</h3>
      <p className="text-sm text-green-600 mt-2">{change}</p>
    </div>
  );
}

export default StatCard;